import { ReactElement } from 'react';
import { DashboardContainer } from '../../../modules/common/dashboard/DashboardContainer';
import { ProjectsHeader } from '../../modules/projects/containers/ProjectsHeader';
import { ProjectsListContainer } from '../../modules/projects/containers/ProjectsList.container';

export const ProjectsView = (): ReactElement => {
  return (
    <DashboardContainer>
      <ProjectsHeader />
      <ProjectsListContainer />
    </DashboardContainer>
  );
};
